import _ from 'lodash'

export const getStopCallItems = state => _.get(state, 'jobStopCallActions.stopCalls.data', [])
export const getStopCallLoading = state => _.get(state, 'jobStopCallActions.loading', false)

// attachments
export const getStopCallAttachments = state => _.get(state, 'jobStopCallActions.attachments', [])
export const getAttachmentsLoading = state =>
  _.get(state, 'jobStopCallActions.loadingAttachments', false)
export const getAttachmentUploading = state =>
  _.get(state, 'jobStopCallActions.uploadingAttachment', false)
export const getAttachmentDeleting = state =>
  _.get(state, 'jobStopCallActions.deletingAttachment', false)

// notes
export const getStopCallNotes = state => _.get(state, 'jobStopCallActions.stopCallNotes.data', [])



// WEBPACK FOOTER //
// ./src/selectors/job/stopCall.js